export const DATE_PARAMETER = 'opdate';
export const ACTIVE_FIELD = 'is_active';
export const RELOAD_TIMEOUT = 10 * 60 * 1000; // 10 min';
